import React from 'react';

import CheckIcon from '@mui/icons-material/Check';
import { Chip, ChipProps, alpha } from '@mui/material';
import { Theme, getContrastRatio } from '@mui/material/styles';

import { actionColour, actionText, tcc } from './palette';
import { CommandFlag } from './types';

export function departureActionChipSx(theme: Theme, flag: CommandFlag | null, selected: boolean) {
  const colour = flag ? actionColour(flag) : tcc.neutralBand;
  // Choose readable text on the solid action colour, including amber, in either theme.
  const contrastText =
    getContrastRatio(colour, theme.palette.common.white) >= 4.5
      ? theme.palette.common.white
      : theme.palette.common.black;
  return {
    bgcolor: selected ? colour : alpha(colour, 0.14),
    color: selected ? contrastText : flag ? actionText(flag) : 'text.secondary',
    border: `${selected ? 2 : 1}px solid`,
    borderColor: selected ? colour : alpha(colour, 0.25),
    fontWeight: selected ? 700 : 500,
    '& .MuiChip-icon': { color: 'inherit', fontSize: 18 },
    '&:hover, &.Mui-focusVisible': {
      bgcolor: selected ? colour : alpha(colour, 0.22),
    },
  };
}

export default function DepartureActionChip({
  flag,
  selected,
  ...props
}: { flag: CommandFlag | null; selected: boolean } & Pick<ChipProps, 'label' | 'onClick'>) {
  return (
    <Chip
      {...props}
      aria-pressed={selected}
      variant={selected ? 'filled' : 'outlined'}
      icon={selected ? <CheckIcon /> : undefined}
      sx={(theme) => departureActionChipSx(theme, flag, selected)}
    />
  );
}
